import { Locale } from "../../types/apis/models/locale.types";
import { fetchSimple, getBaseUrl } from "../api.utils";

export const getAllLocales = async (): Promise<Locale[]> => {
    const baseConfigTemplatesURL = await getBaseUrl("locales");
    return await fetchSimple<Locale[]>(
        `${baseConfigTemplatesURL}`
    );
};